import { useState } from "react";
import Chart from "react-apexcharts";

export default function DoughnutContasContabil({ data }) {
    const [modalInfo, setModalInfo] = useState(null);

    const contas = Object.keys(data?.totalPorContaContabil || {});
    const valoresContas = Object.values(data?.totalPorContaContabil || {});

    const detalhesContas = contas.map((contaContabilRateio, index) => {
        const fornecedor = data?.solicitacoes.find(
            (d) => d.contaContabilRateio === contaContabilRateio
        );
        return {
            conta: contaContabilRateio,
            nome: fornecedor ? fornecedor.nomeContaRateio : "",
            valor: valoresContas[index],
        };
    });

    const options = {
        chart: {
            type: "donut",
            events: {
                dataPointSelection: (event, chartContext, config) => {
                    const index = config.dataPointIndex;
                    setModalInfo(detalhesContas[index]); // abre modal com dados completos
                },
            },
        },
        labels: contas, // categorias
        legend: {
            position: "top",
            fontSize: "12px",
            labels: { colors: "#333" },
        },
        tooltip: {
            y: {
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "65%", // define o tamanho do “buraco”
                },
            },
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    legend: { position: "bottom" },
                },
            },
        ],
    };

    const series = valoresContas;

    return (
        <div className="bg-card border border-border rounded-2xl shadow-soft">
            <h2 className="p-4 text-xl font-display font-bold mb-4 text-foreground">Total por Conta Contábil</h2>
            <Chart options={options} series={series} type="donut" />
            {modalInfo && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-card border border-border p-6 rounded-xl w-96 shadow-pop">
                        <h3 className="text-lg font-display font-bold mb-4 text-foreground">Detalhes da Conta</h3>
                        <p className="text-foreground">
                            <strong>Código:</strong> {modalInfo.conta}
                        </p>
                        <p className="text-foreground">
                            <strong>Nome:</strong> {modalInfo.nome || "—"}
                        </p>
                        <p className="text-foreground">
                            <strong>Valor:</strong>{" "}
                            {Number(modalInfo.valor).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                            })}
                        </p>
                        <button
                            className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:brightness-95 transition-colors duration-150"
                            onClick={() => setModalInfo(null)}
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
